import React from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";

const style = ({ theme }) => ({
  root: {
    flexGrow: "1",
    fontFamily: theme.fonts.serif,
    fontWeight: theme.fontWeights.medium,
    marginLeft: theme.padding.md,
    fontSize: "16px"
  }
});

const StepHeaderTitle = ({ classes, children }) => (
  <div className={classes.root}>{children}</div>
);

StepHeaderTitle.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.node
};

export default injectSheet(style)(StepHeaderTitle);
